<template lang="pug">
.message-register-detail
  // text
  .mb-0
    span.key-name 返信内容
  #text.mb-3
    .mb-0
      span {{ value.text }}

  // file input
  template(v-if="1 <= planType")
    .mt-2.mb-0
      span.key-name 添付ファイル
    #files
      .mb-2(v-show="value.files && value.files.length <= 0")
        span ファイル無し
      .mb-2(v-for="file in value.files")
        .image(v-if="file.type == 'image/jpeg' || file.type == 'image/png'")
          b-img.preview-image(thumbnail fluid :src="createFileUrl(file)" :alt="file.name")
        .video(v-if="file.type == 'video/quicktime' || file.type == 'video/mp4'")
          b-embed.preview-video(type="video" :src="createFileUrl(file)" controls)
        .pdf(v-if="file.type == 'application/pdf'")
          a.pdf-download(:href="createFileUrl(file)" download="HitomeQコネクト-メッセージ送信-添付ファイル.pdf" target="_blank") PDFファイルを開く
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

import { PlanType } from "@/commons/services/Plans";

/**
 * ### 受信メッセージ返信詳細コンポーネント
 */
@Component({})
export default class ReplyReceiveMessageDetail extends Vue {
  @Prop({ required: true })
  value!: ReplyReceiveMessageDetailModel;

  @Prop()
  planType!: PlanType;

  /**
   * ### ファイルからオブジェクトURLを作成する
   */
  public createFileUrl(file: File): string {
    const url: string = window.URL.createObjectURL(file);
    return url;
  }
}

export interface ReplyReceiveMessageDetailModel {
  /** 本文 */
  text: string;
  /** 添付ファイル */
  files: Array<File>;
}
</script>
<style lang="scss" scoped>
.preview-pdf {
  height: 320px;
}
</style>
